import React from 'react';

import styled from 'styled-components';

import Avatar from 'common/Avatar';
import Button from 'components/lib/Button';
import TextArea from 'components/lib/TextArea';

import { ACTOR_TYPE } from '../../../../constants';

const NewComment = styled.div`
  display: flex;
  padding-top: 17px;
`;

const StyledAvatar = styled(Avatar)`
  display: flex;
  align-items: flex-start;
`;

const NewCommentContent = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-left: 10px;
`;

const ActionButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 8px;
`;

type AddCommentProps = {
  avatarUrl?: string | null;
  userName?: string | null;
  dataTestIdPrefix: string;
  comment: string;
  isExpanded: boolean;
  isPosting: boolean;
  onFocus: () => void;
  onChange: (value: string) => void;
  onPost: () => void;
  onCancel: () => void;
};

const AddComment = ({
  avatarUrl,
  userName,
  dataTestIdPrefix,
  comment,
  isExpanded,
  isPosting,
  onFocus,
  onChange,
  onPost,
  onCancel,
}: AddCommentProps) => (
  <NewComment>
    <StyledAvatar size={30} type={ACTOR_TYPE.USER} name={userName ?? ''} src={avatarUrl ?? undefined} />
    <NewCommentContent>
      <TextArea
        value={comment}
        onFocus={onFocus}
        onChange={(event) => onChange(event.target.value)}
        rows={isExpanded ? 3 : 1}
        placeholder="Add a comment..."
        data-test-id={`${dataTestIdPrefix}-new-input`}
      />
      {isExpanded && (
        <ActionButtons>
          <Button
            type="primary"
            onClick={onPost}
            loading={isPosting}
            disabled={!comment.trim()}
            data-test-id={`${dataTestIdPrefix}-post`}
          >
            Post Comment
          </Button>
          <Button onClick={onCancel} disabled={isPosting} data-test-id={`${dataTestIdPrefix}-cancel`}>
            Cancel
          </Button>
        </ActionButtons>
      )}
    </NewCommentContent>
  </NewComment>
);

export default AddComment;
